import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate } from "../Helpers";
import { STR_BUY_NOW, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED } from "../Strings";
import { MdCall, MdMessage, MdPerson, MdWhatsapp } from "react-icons/md";

export default function OneClient({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		appContext.navTo({
			item: "side-view",
			subItem: "vendor",
			extraItem: data.uuid,
		});
	}

	return (
		<div
			className="mShadow1"
			onClick={view}
			style={{
				padding: "10px",
				paddingTop: "20px",
				paddingBottom: "20px",
				borderBottom: "0px solid var(--secondaryColor)",
				cursor: "pointer",
			}}
		>
			<div className="d-flex mb-3">
				<MdPerson 
					size={28}
					style={{
						flexShrink: 0,
					}}
					className="align-self-center mNoMargin text-muted"
				/>
				<h6
					style={{
						fontSize: "22px",
						flexShrink: 0,
					}}
					className="font-light align-self-center mNoMargin"
				>
					
					{data.name}
				</h6>
			</div>

			<h6
				style={{
					fontSize: "14px",
				}}
				className="font-semi-bold text-end text-muted"
			>
				<MdCall/> {data.phone || 'N/A'}
			</h6>

			
		</div>
	);
}
